<template>
  <div>
    <b-card class="bg-t-dark">
        <b-row>
            <b-col md="2">
                <b-row>
                    <b-col class="text-center">
                        <EnlightMockupImg/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="m-1 text-center">
                        <h5 id="serial-number-card">
                            {{serial_number}}
                        </h5>
                    </b-col>
                </b-row>
            </b-col>
            <b-col md="6">
                <b-row>
                    <b-col>
                        <b-row class="mt-1 mt-om">
                            <b-col>
                                <b-row>
                                    <b-col>
                                        {{$t("Register date")}}: {{date}}
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <b-row class="mt-1 mt-om">
                            <b-col>
                                <b-row>
                                    <b-col>
                                        {{$t("Mode")}}: {{mode}}
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
            <b-col md="4" class="text-end-od" align="end">
                <b-row>
                    <b-col>
                        {{$t("Serial number")}}: {{serial_number}}
                    </b-col>
                </b-row>
                <b-row class="order-card-buttons  mt-om">
                    <b-col>
                        <b-btn id="equipment-detail" class="m-2 w-100-only-mobile" variant="t-blue" @click="$router.push(`equipment-details/?id=${device_id}`)">
                            {{$t("Settings")}}
                        </b-btn>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-card>
  </div>
</template>

<script>
import EnlightMockupImg from '@/assets/img/EnlightMockupImg'

export default {
    components:{
        EnlightMockupImg
    },
    props: [
        "device_id",
        'serial_number',
        'mode',
        'date',
        'device_name'
    ]
}
</script>

<style lang="scss">
@media only screen and (max-width: 600px) {
    .btn{
        margin-bottom: 5px;
    }
}
@media only screen and (min-width: 600px) {
    .order-card-buttons{  
        position: absolute;
        bottom: 15px;
        right: 15px;
    }
}

</style>